<template>
  <div>
    <title-row
      :title="page.title"
      :subtitle="page.subtitle"
      :breadcrumb-items="[
        {
          text: 'Kapcsolatok',
          to: { name: 'ConnectionList' },
        },
        page.breadcrumbItem,
      ]"
    >
      <template #buttons>
        <title-row-button @click="save" :loading="loading">
          <v-icon left>mdi-check</v-icon>
          Mentés
        </title-row-button>
      </template>
    </title-row>

    <loading-overlay v-if="loading" />

    <v-row>
      <v-col :cols="12" :lg="6">
        <v-card class="rounded-xl">
          <v-card-title>Alapadatok</v-card-title>
          <v-card-text>
            <v-masked-text-field
              label="Megnevezés"
              :error-messages="errors.name"
              v-model="form.name"
              filled
            />
            <v-select
              label="Átjáró"
              :error-messages="errors.gateway_id"
              v-model="form.gateway_id"
              :items="gateways"
              item-text="name"
              item-value="element_id"
              filled
              :value-comparator="$config.comparators.isEqual"
            />
            <v-masked-text-field
              label="RS232 Port név"
              :error-messages="errors.rs232_port_dev_name"
              v-model="form.rs232_port_dev_name"
              filled
            />
            <v-masked-text-field
              label="RS232 Baud rate"
              :error-messages="errors.rs232_baud_rate"
              v-model="form.rs232_baud_rate"
              filled
              :mask="$config.inputMasks.createNumberMask({ min: 0, max: 921600 })"
            />
            <v-masked-text-field
              label="Ip"
              :error-messages="errors.ip"
              v-model="form.ip"
              filled
              :mask="$config.inputMasks.ipAddress"
            />
            <v-masked-text-field
              label="Port"
              :error-messages="errors.port"
              v-model="form.port"
              filled
              :mask="$config.inputMasks.createNumberMask({ min: 1, max: 65535 })"
              placeholder="1-65535"
            />
            <v-textarea
              label="Megjegyzés"
              :error-messages="errors.comment"
              v-model="form.comment"
              filled
              rows="3"
              auto-grow
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {},
      buildings: [],
      gateways: [],
      errors: {},
      loading: false
    };
  },

  mounted() {
    this.fetchGateways();
    this.fetchConnection();
  },

  methods: {
    async fetchConnection() {
      this.loading = true;
      try {
        const response = await this.$http.get(`connections/details/${this.$route.params.id || 0}`);
        this.form = response.connection;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    async fetchGateways() {
      this.loading = true;
      try {
        const response = await this.$http.get(`gateways/list`);
        this.gateways = response.gateways;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    async save() {
      this.loading = true;
      this.errors = {};

      try {
        const response = await this.$http.post('connections/save', this.form);

        this.loading = false;

        if (Object.keys(response.errors).length) {
          return this.errors = response.errors;
        }
        this.$dialog.notify.success('Sikeres mentés');
        this.$router.replace({ name: 'ConnectionList' });
      } catch (e) {
        this.$dialog.notify.error(e);
      }
    },
  },
  computed: {
    page() {
      switch (this.$route.name) {
        case 'NewConnection':
          return {
            isNew: true,
            title: 'Új kapcsolat létrehozása',
            breadcrumbItem: {
              text: 'Új kapcsolat',
              disabled: true,
            },
          };
        case 'ConnectionEditor':
          return {
            isNew: false,
            title: `Kapcsolat: ${this.form.name ?? 'Betöltés...'}`,
            //subtitle: `Tulajdonos: ${this.cardOwnerName ?? 'Betöltés...'}`,
            breadcrumbItem: {
              text: this.form.name,
              disabled: true,
            },
          };
      }
      return {};
    },
  }
};
</script>
